import { e } from '../utils/dom';

// import BlazeSlider from 'blaze-slider'
import BlazeSlider from './blaze'
// import 'blaze-slider/dist/blaze.css'

export const initSlider = function () {
    const sliderEl = document.querySelector('.blaze-slider');
    //destroy old BlazeSlider on category change
    if (sliderEl.blazeSlider) {
        sliderEl.blazeSlider.destroy();
    }

    const slider = new BlazeSlider(sliderEl, {
        transitionDuration: 500, // (300 is default)
    });

    slider.onSlide(() => {
        window.topNewsReload.postpone();
    });

    //for server-side rendered slides (non-first slides are display:none on load) so images are loaded lazily
    sliderEl.querySelectorAll('.carousel-slide').forEach(el =>el.style.display = 'flex');

    //loading="lazy" actually does not work as expected on Chrome in slider, so we use IntersectionObserver to load images when visible
    const observerOptions = {
        root: sliderEl, // The sliding container
        threshold: 0.1 // Trigger when 10% of the slide is visible
    };

    function loadActualImage(img) {
        // Swap data-src to src
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
        if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
        }
    }

    //we delay loading image for next slide so other content which is more important is loaded first
    function loadSliderImages(slideEl) {
        if (!slideEl) {
            return;
        }
        slideEl.querySelectorAll('[data-src],[data-srcset]').forEach(img => {
            loadActualImage(img);
        });
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                loadActualImage(img);
                // Stop watching this image once it's loaded
                observer.unobserve(img);
            }
        });
    }, observerOptions);

    sliderEl.querySelectorAll('[data-src],[data-srcset]').forEach(img => observer.observe(img));

    //carousel-slide-0 is 1st slide carousel-slide-1 is 2nd slide
    if ('requestIdleCallback' in window) {
        requestIdleCallback(function() {
            //lazy load next slide images 1 second after browser is idle
            setTimeout(() => {
                loadSliderImages(sliderEl.querySelector('.carousel-slide-1'));
            }, 1000)
        }, { timeout: 3000 }); //wait max 3 seconds until browser is idle befor lazy loading next slide images
    } else {
        //legacy fallback
        setTimeout(() => {
            loadSliderImages(sliderEl.querySelector('.carousel-slide-1'));
        }, 3000);
    }

    //on slide change delayed-load images for next slide
    slider.onSlide((pageIndex) => {
        loadSliderImages(sliderEl.querySelector(`.carousel-slide-${(pageIndex + 1)}`));

        //in GTM there is defined generic custom_interaction trigger, so we can make custom events more easily
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'custom_interaction', // This stays the same for every call
                'event_name': 'top_news_slide', // The dynamic GA4 event name
                'event_params': {
                    'slide_id': pageIndex,
                    'slide_type': 'all_types'
                }
            });
        }
    });

    function handleDotsClick(el) {
        //get button index among siblings to know which slide it corresponds to
        const pageIndex = Array.from(el.parentNode.children).indexOf(el);
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'custom_interaction', // This stays the same for every call
                'event_name': 'top_news_slide', // The dynamic GA4 event name
                'event_params': {
                    'slide_id': pageIndex,
                    'slide_type': 'dots_click'
                }
            });
        }
    }

    //todo when/if arrows are added, track custom slide_type something like 'arrows_click'

    sliderEl.querySelectorAll('.blaze-pagination button').forEach(
        el => el.addEventListener('click', () => handleDotsClick(el))
    );
};

export const fillTopSlider = function (newsItems, categories, categoryChosen) {
    document.querySelectorAll('.news-categories li').forEach( (el) => el.classList.remove('active'));
    document.querySelector('.news-categories a[data-filtercategory="' + (categoryChosen === 0 ? null : categoryChosen) + '"]')?.parentNode.classList.add('active');

    const getBgImgUrl = (currNews, imgWidth, imgHeight) => {
        //creates image url with specific size. not always .jpg, can be also .jped
        //example:
        // this: https://master-portal.indev.lv/w/img/ed/11/ed11c8af87333ea6b6.jpg
        // becomes: https://master-portal.indev.lv/w/img/ed/11/ed11c8af87333ea6b6-120x63.jpg
        const url = currNews.imageUrl;
        if (!url) {
            return null;
        }

        const urlParts = url.split('/');
        const imageName = urlParts.pop();
        const imageExtension = imageName.split('.').pop();
        const imageHash = imageName.split('.')[0];

        const imageBaseUrl = urlParts.join('/');

        var backgroundImageSuffix = '-' + imgWidth + 'x' + imgHeight+  '.';

        return imageBaseUrl + '/' + imageHash + backgroundImageSuffix + imageExtension;
    }

    const chunkWithMinSize = (arr, chunkSize, minChunkSize = 0) => {
        const remainder = arr.length % chunkSize;
        const isLastChunkTooSmall = remainder < minChunkSize;
        const totalChunks = isLastChunkTooSmall
            ? Math.floor(arr.length / chunkSize)
            : Math.ceil(arr.length / chunkSize);
        return Array.from({ length: totalChunks }, (_, i) => {
            const chunk = arr.slice(i * chunkSize, i * chunkSize + chunkSize);
            if (i === totalChunks - 1 && isLastChunkTooSmall)
                chunk.push(...arr.slice(-remainder));
            return chunk;
        });
    };

    let slides = [];
    const chunkedNewsItems = chunkWithMinSize(newsItems, 8, 8);
    const wider_container = !!document.querySelector('.wider_container');
    for (let slideIndex = 0; slideIndex < chunkedNewsItems.length; slideIndex++) {
        if (chunkedNewsItems[slideIndex].length > 8) {
            chunkedNewsItems[slideIndex].splice(8, chunkedNewsItems[slideIndex].length - 8);
        }
        if (chunkedNewsItems < 8) {
            break;
        }

        const slide = `
                    <div class="carousel-slide carousel-slide-${slideIndex}">
                        <ul class="news-items d-flex flex-column ps-0">
                        ${chunkedNewsItems[slideIndex].map((item, newsItemsIndex) => `
                            <li>
                                <article>
                                    <a href="${item.newsLink}&source=portal" target="_blank" title="${e(item.title)}">
                                        <figure>
                                            <picture>
                                                ${(newsItemsIndex === 0 || (newsItemsIndex === 1 && wider_container)) ? `<source media="(max-width: 768px) or (min-width: ${wider_container ? '1200px' : '1900px'})" srcset="${getBgImgUrl(item, 540, 300)}">` : ``}
                                                <img class="rounded-3" src="${getBgImgUrl(item, 140, 100)}" width="77" height="48" alt="img"
                                                 ${slideIndex === 0 && (newsItemsIndex === 0 || (newsItemsIndex === 1 && wider_container)) ? 'fetchpriority="high"' : 'loading="lazy"'}/>
                                            </picture>
                                        </figure>
                                        <div class="news-item-content">
                                            <h3 title="${e(item.title)}">
                                                ${e(item.title)}. <span>${e(item.shortDescription)}</span>
                                            </h3>
                                            <p>${e(item.shortDescription)}</p>
                                            <p>${e(item.sourceName)}</p>
                                        </div>
                                    </a>
                                </article>
                            </li>
                        `).join('')}
                        </ul>
                    </div>
                `;
        slides.push(slide);
    }
    document.querySelector('.wrap-carousel .carousel-inner').innerHTML = slides.join('');

    initSlider();
};
